<template>
  <vs-popup
    class="add-subib-rule-dialog"
    :title="title"
    :active.sync="isDialogShow"
  >
    <div class="dialog-content">
      <el-form
        ref="form"
        label-position="top"
        :model="form"
        :rules="rules"
      >
        <el-form-item
          :label="$t('Sub_IB_level_name')"
          prop="subIbLevelName"
        >
          <el-input
            v-model="form.subIbLevelName"
          ></el-input>
        </el-form-item>
      </el-form>
      <commission-rule-group
        ref="rulegroup"
        :rule-data="templateList"
        @submit="ruleGroupSubmitHandle"
      ></commission-rule-group>
    </div>
    <div class="footer-sidebar">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import { addTMerchantCommissionLevelsRule } from '@/api/userCenter.js';
import commissionRuleGroup from "@/components/agent/propagandas/commissionRuleGroup";
import { mapGetters } from 'vuex'
import { throttle } from "@/utils";
export default {
  name: "addSubIbRuleDialog",
  components:{
    commissionRuleGroup,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    templateList:{
      type: Array,
      default(){
        return []
      }
    },
  },
  data() {
    let _this = this;
    return {
      title: _this.$t('Add_sub_IB_link'),
      isDisabeld: false,
      isDialogShow: this.dialogShow,
      // 防止重复提交的标志
      isSubmitting: false,
      form: {
        subIbLevelName: '',
      },
      rules: {
        subIbLevelName: [
          { required: true,message: _this.$t('Please_enter_the_sub_IB_level_name'), trigger: 'blur', },
        ]
      }
    }
  },
  watch: {
    dialogShow(newVal) {
      this.isDialogShow = newVal;
      // 每次打开对话框时重置状态
      if (newVal) {
        this.resetDialogState();
      }
    },
    isDialogShow(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor']),
  },
  methods: {
    // 重置对话框状态
    resetDialogState(){
      // 重置表单
      this.form.subIbLevelName = '';
      if(this.$refs.form){
        this.$refs.form.clearValidate();
      }
      // 重置佣金规则组件的状态
      if(this.$refs.rulegroup){
        this.$refs.rulegroup.resetValidateStatus();
      }
    },
    ruleGroupSubmitHandle(newRules) {
      // 设置提交中标志
      this.isSubmitting = true;
      
      addTMerchantCommissionLevelsRule({
        name: this.form.subIbLevelName,
        custId: this.userInfo.id,
        newRules: newRules
      }).then((res) => {
        this.$emit('add-success');
        this.$message({
          type: 'success',
          message: this.$t('User.addPhoneSuccess')
        });
        this.$refs.rulegroup.clearCom();
        this.isSubmitting = false; // 提交成功后重置标志
      }).catch(() => {
        this.isSubmitting = false; // 出错时也要重置标志
      });
    },
    close(){
      this.isDialogShow = false;
    },
    closeHandle() {
      this.close();
    },
    submitHandle: throttle(function() {
      // 如果正在提交中，直接返回
      if (this.isSubmitting) {
        return;
      }
      
      this.$refs.form.validate((valid) => {
        if(valid){
          // 验证规则
          this.$refs.rulegroup.validateTable();
        }else {
          console.log('no-pass');
        }
      })
    }, 2000),
    cancelHandle(){
      this.close();
    }
  },
}
</script>

<style lang="scss">
.add-subib-rule-dialog {
  .vs-popup {
    width: 1280px;
    max-width: 95vw;
    min-width: 320px;
    @media (max-width: 768px) {
      width: 95vw;
    }
    .vs-popup--header {
      .vs-popup--title {
        h3 {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .vs-popup--content {
      padding: 0;
      max-height: 70vh;
      overflow-y: auto;
    }
  }
  .dialog-content {
    padding: 20px;
  }
  .footer-sidebar {
    padding: 15px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #e8e8e8;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
